module.exports = __webpack_public_path__ + "assets/3845cafdda15c94487b66c4c1baa9114.mp3";